import { api } from './index';
export const orderReportsApi = { create(orderReport) { const path = '/api/internal/order_reports'; return api({ method: 'post', url: path, data: orderReport }).then(response => response.data); } };
